export const actions = {
    SHOW_DETAILS: 'SHOW_DETAILS',
    SHOW_LIST: 'SHOW_LIST',
    HOVER_STATION: 'HOVER_STATION',
    HOVER_END_STATION: 'HOVER_END_STATION',
    SORT_STATIONS: 'SORT_STATIONS',
    FETCH_STATIONS: 'FETCH_STATIONS',
    STATIONS_FETCHED: 'STATIONS_FETCHED',
    FETCHING_STATIONS_FAILED: 'FETCHING_STATIONS_FAILED',
    SHOW_ALL_COSTS: 'SHOW_ALL_COSTS',
    HIDE_ALL_COSTS: 'HIDE_ALL_COSTS',
    SHOW_CHANGE_POSTCODE_FORM: 'SHOW_CHANGE_POSTCODE_FORM',
    HIDE_CHANGE_POSTCODE_FORM: 'HIDE_CHANGE_POSTCODE_FORM',
    CLEAR_STATION: 'CLEAR_STATION',
    SET_QUANTITY: 'SET_QUANTITY',
};
